import * as _ from 'lodash';
import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import Page from 'src/components/common/Page';
import Client from 'src/models/AP/Client';
import Panel from 'src/components/common/Panel';
import Button from 'src/components/controls/forms/redesign/FormButton';
import RHFCheckbox from 'src/components/controls/tempRHFControls/RHFCheckBox';
import RHFInputBox from 'src/components/controls/tempRHFControls/RHFInputBox';
import RHFSelect from 'src/components/controls/tempRHFControls/RHFSelect';
import useFetch from 'use-http';
import DialogList from 'src/dialogs';
import actions from 'src/actions';
import Voucher from 'src/models/AP/VoucherMaintenanceForm';
import { BiAddToQueue, BiLeftArrowAlt, BiRightArrowAlt, BiArrowToLeft, BiArrowToRight } from 'react-icons/bi';
import { FaRegSave } from 'react-icons/fa';
import { BsSearch } from 'react-icons/bs';
import { FaUserTie } from 'react-icons/fa';
import { VscGraph } from 'react-icons/vsc';
import { ODataOptions, ODataFilter, ODataFilterOperators, ODataOrderByDirection } from 'src/util/ODataBuilder';
import { ITableConfig } from 'src/components/common/table';
import CPNavBar from '../CPNavBar';
import FindClientDialog from  '../dialogs/FindClientDialog';
import TsdiClient from 'src/models/AP/Client';
import { FormRow } from 'src/components/controls/forms/reactHookForm';
import TsdiClientInfo from 'src/models/AP/ClientInfo';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import './ClientMaintenancePage.css';
import ClientProjectSearch from 'src/components/project-billing/components/ClientProjectSearch';
import ReportOptionsDialog from 'src/components/accounts-payable/dialogs/ReportOptionsDialog';

const ClientMaintenancePage = () => {
    const dispatch = useDispatch();
    const [masterServicesAgreementDate, setMasterServicesAgreementDate] = useState<Date | [Date, Date]>(null);
    const { get, post, put, response } = useFetch();
    const { reset, register, handleSubmit, formState, errors } = useForm();
    const { register: registerClientInfoForm, reset: resetClientInfoForm, formState: formStateClientInfoForm, getValues: getValuesClientInfoForm} = useForm();
    const { register: registerClientInfoFormSection2, reset: resetClientInfoFormSection2, getValues: getValuesClientInfoFormSection2, formState: formStateClientInfoFormSection2 } = useForm();
    const [selectedClient, setSelectedClient] = useState<TsdiClient>(undefined);
    const [clientInfo, setClientInfo] = useState<TsdiClientInfo>(undefined);
    const [currentMileageRate, setCurrentMileageRate] = useState<number>(undefined);
    const [clients, setClients] = useState<Array<TsdiClient>>(undefined);
    const [clientTypes, setClientTypes] = useState<{ code: number, description: string}[]>([]);
    const [useClientAddressForBilling, setUseClientAddressForBilling] = useState<boolean>(false);
    const [partnerAgreementRequired, setPartnerAgreementRequired] = useState<boolean>(false);
    const [ndaRequired, setNdaRequired] = useState<boolean>(false);
    const [masterServicesAgreementRequired, setMasterServicesAgreementRequired] = useState<boolean>(false);
    const [subConsultantAgreementRequired, setSubConsultantAgreementRequired] = useState<boolean>(false);
    const [noGiftPolicy, setNoGiftPolicy] = useState<boolean>(false);
    const [workOrderRequired, setWorkOrderRequired] = useState<boolean>(false);
    const [clientSearchOptions, setClientSearchOptions] = useState<ODataOptions>(undefined);
    const [clientSearchTerm, setClientSearchTerm] = useState<string>(undefined);
    const [fetchNextPage, setFetchNextPage] = useState<boolean>(true);
    const [addingClient, setAddingClient] = useState<boolean>(false);
    const [tsdiAccounts, setTsdiAccounts] = useState<{ code: number, description: string}[]>(undefined);
    const { isDirty } = formState;
    const { isDirty: isDirtyClientInfoForm } = formStateClientInfoForm;
    const { isDirty: isDirtyClientInfoFormSection2 } = formStateClientInfoFormSection2;
    // TODO: Finish billing code validation
    // const [timeAndExpenseToken, setTimeAndExpenseToken] = useState<string>('');
    // const [clientValidations, setClientValidations] = useState<Array<boolean>>([]);

    // Initial render
    useEffect(() => {
        onCreate();

        // TODO: *cry* 😭✅
        return () => {
            onDestroy();
        };
    }, []);

    useEffect(() => {
        if (!!clientInfo) {
            if (clientInfo?.useBillingAddress !== undefined) {
                setUseClientAddressForBilling(clientInfo?.useBillingAddress);
            }
            if (clientInfo?.partnerAgreementRequired !== undefined) {
                setPartnerAgreementRequired(clientInfo?.partnerAgreementRequired);
            }
            if (clientInfo?.subConsultantAgreement !== undefined) {
                setSubConsultantAgreementRequired(clientInfo?.subConsultantAgreement);
            }
            if (clientInfo?.masterServicesAgreement !== undefined) {
                setMasterServicesAgreementRequired(clientInfo?.masterServicesAgreement);
            }
            if (clientInfo?.partnerAgreementRequired !== undefined) {
                setPartnerAgreementRequired(clientInfo?.partnerAgreementRequired);
            }
            if (clientInfo?.noGiftPolicy !== undefined) {
                setNoGiftPolicy(clientInfo?.noGiftPolicy);
            }
            if (clientInfo?.workOrderRequired !== undefined) {
                setWorkOrderRequired(clientInfo?.workOrderRequired);
            }
            if (clientInfo?.ndaRequired !== undefined) {
                setNdaRequired(clientInfo?.ndaRequired);
            }
            if (!!clientInfo?.masterServicesAgreementDate) {
                setMasterServicesAgreementDate(new Date(clientInfo.masterServicesAgreementDate));
            }
            const section2Values = getValuesClientInfoFormSection2();
            console.log(section2Values);
            resetClientInfoForm(clientInfo);
            resetClientInfoFormSection2(clientInfo);
        }
    }, [clientInfo]);

    useEffect(() => {
        if (!!addingClient) {
            showDialog(DialogList.FIND_CLIENT);
        }
    }, [addingClient]);

    useEffect(() => {
        if (!!selectedClient) {
            reset({ clientNumber: selectedClient?.clientNumber, clientName: selectedClient?.clientName });
            getClientInfo(selectedClient?.clientNumber);
            if (!!clients && clients?.length > 0) {
                const displayClient = clients.find((c) =>
                    c.clientNumber === selectedClient?.clientNumber
                );
                if (displayClient !== undefined) {
                    reset(displayClient);
                } else {
                    setClientSearchTerm(selectedClient?.clientNumber?.toString());
                }
            }
        }
    }, [selectedClient]);

    useEffect(() => {
        if (!!clientSearchTerm || clientSearchTerm === '') {
            resetClientSearchOptions();
        }
    }, [clientSearchTerm]);

    useEffect(() => {
        if (!!clientSearchOptions) {
            getClients();
        }
    }, [clientSearchOptions]);

    useEffect(() => {
        if (!!clients && clients?.length > 0) {
            if (clients.length === 1 && clients[0].clientNumber === selectedClient?.clientNumber ) {
                const displayClient = clients.find((c) =>
                    c.clientNumber === selectedClient?.clientNumber
                );
                if (displayClient !== undefined) {
                    reset(displayClient);
                }
            }
        }
    }, [clients]);

    const moveToFirstClient = () => {
        if (clients?.length !== undefined && clients.length > 0) {
            setSelectedClient(clients[0]);
        }
    };

    const moveToLastClient = () => {
        if (clients?.length !== undefined && clients.length > 0) {
            setSelectedClient(clients[clients.length - 1]);
        }
    };

    const moveToNextClient = () => {
        if (clients?.length !== undefined && clients.length > 0) {
            setSelectedClient(clients[clients.length - 1]);
        }
    };

    const moveToPreviousClient = () => {
        if (clients?.length !== undefined && clients.length > 0) {
            setSelectedClient(clients[0]);
        }
    };

    const getClientInfo = async (clientNumber: number) => {
        let result = await get(`/v1.0/ClientProjectMaintenance/client/info/${clientNumber}`);

        if (response.ok) {
            setClientInfo(result);
        } else {
            setClientInfo(new TsdiClientInfo());
            console.log('Unable to get client info data!');
        }
    };

    const getCurrentMileageRate = async () => {
        let result = await get(`/v1.0/ClientProjectMaintenance/client/billing/mileagerate/current`);

        if (response.ok) {
            setCurrentMileageRate(result);
        } else {
            setCurrentMileageRate(.7);
            console.log('Unable to get mileage rate!');
        }
    };

    const initializeClientSearchSettings = () => {
        const tableConfig: ITableConfig = {
            rowCount: 100,
            idField: 'CL_NO',
            pageNumber: 1,
            columns: []
        };
        setClientSearchOptions(ODataOptions.from(tableConfig).addOrderBy('NAME1', ODataOrderByDirection.Ascending));
    };

/*     const addClient = async (payload: Client) => {
        let result = await post(`/v1.0/AccountsPayable/clients`, payload);

        if (response.ok) {
            console.log('successfully added a client ' + result);
        } else {
            console.log('Unable to get client data!');
        }
    }; */

    const updateClientInfo = async (data: TsdiClientInfo) => {
        let result = await put(`/v1.0/ClientProjectMaintenance/client/info`, data);

        if (!response.ok) {
            alert('Unable to update client info data: ' + result);
        } else {
            setSelectedClient(selectedClient);
        }
    };

    const addTsdiClient = async (payload: Client) => {
        let result = await post(`/v1.0/ClientProjectMaintenance/client`, payload);

        if (response.ok) {
            getClientInfo(result);
            hideDialog();
        } else {
            console.log('Unable to get client data!');
        }
    };

    const getBillingAccounts = async () => {
        let result = await get(`/v1.0/AccountsPayable/billing/accounts`);

        if (response.ok) {
            setTsdiAccounts(result);
        } else {
            console.log('Unable to get Billing Accounts Data!!!');
        }
    };

    const incrementClients = () => {
        if (!!fetchNextPage) {
            let newSearchOptions = _.cloneDeep(clientSearchOptions);
            newSearchOptions.incrementPageNumber();
            setClientSearchOptions(newSearchOptions);
        }
    };

    /**
     * This function will be called when the Page is first rendered or the user enters the Page
     */
    const onCreate = () => {
        console.log('VouchersPage onCreate()');
        setAddingClient(false);
        getClientTypes();
        getBillingAccounts();
        initializeClientSearchSettings();
        getCurrentMileageRate();
    };

    /**
     * This function will be called when the user leaves the Page
     */
    const onDestroy = () => {
        console.log('VouchersPage onDestroy()');
    };

    const showDialog = (dialog: DialogList) => {
        dispatch(actions.layout.showDialog(dialog));
    };

    const onCancel = () => {
        setAddingClient(false);
        dispatch(actions.layout.hideDialog());
    };

    const hideDialog = () => {
        setAddingClient(false);
        dispatch(actions.layout.hideDialog());
    };

    const reportOptions = () => {
        showDialog(DialogList.REPORT_OPTIONS);
    };

    const onSubmit = async (data: Voucher) => {
        if (!!data) {
            let finalData = finalizeData(data);
            console.log(finalData);
        }
    };

    const finalizeData = (data: Voucher) => {
        // Get all the form values, then add in the Personnel model values that the form doesn't have
        let finalData: Voucher = {
            ...data,
        };

        return finalData;
    };

    const getClients = async () => {
        const queryString = clientSearchOptions?.toString();
        let result = await get(`/v1.0/AccountsPayable/clients${queryString}`);

        if (response.ok) {
            setClients([]);
            setClients(result.items);

        } else {
            setClients([]);
            console.log('Unable to get client data!');
        }
    };

    const getClientTypes = async () => {
        let result = await get(`/v1.0/ClientProjectMaintenance/clients/types`);

        if (response.ok) {
            setClientTypes([]);
            setClientTypes(result);
        } else {
            setClientTypes([]);
            console.log('Unable to get client type data!');
        }
    };

    const resetClientSearchOptions = () => {
        setFetchNextPage(true);
        let newClientSearchOptions = _.cloneDeep(clientSearchOptions);
        newClientSearchOptions.clearFilters();
        newClientSearchOptions.addPaging(1, 50);
        if (typeof clientSearchTerm === 'string') {
            const fieldValues = clientSearchTerm.split(',');
            if (fieldValues[0] !== undefined && !isNaN(Number(fieldValues[0]))) {
                newClientSearchOptions.addFilter(new ODataFilter('CL_NO', ODataFilterOperators.Equals, !!clientSearchTerm ? fieldValues[0] : ''));
            }
            if (fieldValues[1] !== undefined) {
                newClientSearchOptions.addFilter(new ODataFilter('NAME1', ODataFilterOperators.Contains, !!clientSearchTerm ? fieldValues[1] : ''));
            }
            if (fieldValues[2] !== undefined) {
                newClientSearchOptions.addFilter(new ODataFilter('NAME2', ODataFilterOperators.Contains, !!clientSearchTerm ? fieldValues[2] : ''));
            }
            if (fieldValues[3] !== undefined) {
                newClientSearchOptions.addFilter(new ODataFilter('CITY', ODataFilterOperators.Contains, !!clientSearchTerm ? fieldValues[3] : ''));
            }
            if (fieldValues[4] !== undefined) {
                newClientSearchOptions.addFilter(new ODataFilter('STATE', ODataFilterOperators.Contains, !!clientSearchTerm ? fieldValues[4] : ''));
            }
            if (fieldValues[5] !== undefined) {
                newClientSearchOptions.addFilter(new ODataFilter('ZIP', ODataFilterOperators.Contains, !!clientSearchTerm ? fieldValues[5] : ''));
            }
            if (fieldValues[6] !== undefined) {
                newClientSearchOptions.addFilter(new ODataFilter('PHONE', ODataFilterOperators.Contains, !!clientSearchTerm ? fieldValues[6] : ''));
            }
        }
        setClientSearchOptions(newClientSearchOptions);
    };

    const findClient = (addNewClient: boolean) => {
        if (!!addNewClient) {
            setAddingClient(true);
        } else {
            setAddingClient(false);
            showDialog(DialogList.FIND_CLIENT);
        }
    };

    const displayTitle = () => {
        const title = 'Client Maintenance';

        return title;
    };

    const handleReport = () => {
        alert('Not implemented!');
    };

    const displayClientInfo = () => {
        return (
            <>
            <form>
                <div style={{display: 'inline-block', marginTop: '1rem'}}>
                    <RHFInputBox
                        labelOnLeft={true}
                        label="Name"
                        name={'clientName'}
                        style={{width: '100%'}}
                        bodyStyle={{width: '100%'}}
                        register={registerClientInfoForm}
                    />
                    <RHFInputBox
                        labelOnLeft={true}
                        label="Address"
                        name={'address'}
                        style={{width: '100%'}}
                        bodyStyle={{width: '100%'}}
                        register={registerClientInfoForm}
                    />
                    <RHFInputBox
                        name={'address3'}
                        style={{width: '100%'}}
                        bodyStyle={{width: '100%'}}
                        register={registerClientInfoForm}
                    />
                    <RHFInputBox
                        name={'address3'}
                        style={{width: '100%'}}
                        bodyStyle={{width: '100%'}}
                        register={registerClientInfoForm}
                    />
                    <div style={{display: 'flex'}}>
                        <RHFInputBox
                            labelOnLeft={true}
                            label="Country"
                            name={'country'}
                            style={{width: '100%'}}
                            bodyStyle={{width: '100%'}}
                            register={registerClientInfoForm}
                        />
                        <RHFInputBox
                            labelOnLeft={true}
                            label="Postal Code"
                            name={'zipCode'}
                            style={{width: '100%'}}
                            bodyStyle={{width: '100%'}}
                            register={registerClientInfoForm}
                        />
                    </div>                    
                    <div style={{display: 'flex'}}>
                        <RHFInputBox
                            labelOnLeft={true}
                            label="City"
                            name={'city'}
                            style={{width: '100%'}}
                            bodyStyle={{width: '100%'}}
                            register={registerClientInfoForm}
                        />
                        <RHFInputBox
                            labelOnLeft={true}
                            label="State"
                            name={'state'}
                            style={{width: '100%'}}
                            bodyStyle={{width: '100%'}}
                            register={registerClientInfoForm}
                        />
                    </div>
                        <RHFInputBox
                            labelOnLeft={true}
                            label="Phone"
                            name={'phone'}
                            style={{width: '100%'}}
                            bodyStyle={{width: '100%'}}
                            register={registerClientInfoForm}
                        />
                        <RHFInputBox
                            labelOnLeft={true}
                            label="Fax"
                            name={'fax'}
                            style={{width: '100%'}}
                            bodyStyle={{width: '100%'}}
                            register={registerClientInfoForm}
                        />
                    </div>
                    <RHFInputBox
                        labelOnLeft={true}
                        label="Website/Email"
                        name={'emailAddress'}
                        style={{width: '100%'}}
                        bodyStyle={{width: '100%'}}
                        register={registerClientInfoForm}
                    />
                </form>            
            </>
        );
    };

    const displayClientBillingAddress = () => {
        return (
            <>
                <form>
                    <div style={{display: 'inline-block', marginTop: '1rem'}}>
                        <RHFCheckbox
                            label="Use Billing Address?"
                            labelStyle={{whiteSpace: 'nowrap', verticalAlign: 'middle'}}
                            style={{whiteSpace: 'nowrap', verticalAlign: 'middle'}}
                            name="useBillingAddress"
                            checked={useClientAddressForBilling}
                            register={registerClientInfoForm}
                            bodyStyle={{ whiteSpace: 'nowrap', verticalAlign: 'middle', width: '16%', marginTop: '.5rem' }}
                            errors={errors}
                            onChange={() => setUseClientAddressForBilling(!useClientAddressForBilling)}
                        />
                        <RHFInputBox
                            labelOnLeft={true}
                            label="Name"
                            name={'billingClientName'}
                            style={{width: '200px'}}
                            register={registerClientInfoForm}
                        />
                        <RHFInputBox
                            labelOnLeft={true}
                            label="Address"
                            name={'billingAddress'}
                            style={{width: '200px'}}
                            register={registerClientInfoForm}
                        />
                        <RHFInputBox
                            name={'billingAddress2'}
                            style={{width: '200px'}}
                            register={registerClientInfoForm}
                        />
                        <RHFInputBox
                            name={'billingAddress3'}
                            style={{width: '200px'}}
                            register={registerClientInfoForm}
                        />
                        <div style={{display: 'flex'}}>
                            <RHFInputBox
                                labelOnLeft={true}
                                label="Country"
                                name={'billingCountry'}
                                style={{width: '200px'}}
                                register={registerClientInfoForm}
                            />
                            <RHFInputBox
                                labelOnLeft={true}
                                label="Postal Code"
                                name={'billingZipCode'}
                                style={{width: '200px'}}
                                register={registerClientInfoForm}
                            />
                        </div>                    
                        <div style={{display: 'flex'}}>
                            <RHFInputBox
                                labelOnLeft={true}
                                label="City"
                                name={'billingCity'}
                                style={{width: '20px'}}
                                register={registerClientInfoForm}
                            />
                            <RHFInputBox
                                labelOnLeft={true}
                                label="State"
                                name={'billingState'}
                                style={{width: '50px'}}
                                register={registerClientInfoForm}
                            />
                        </div>
                    </div>
                </form>
            </>
        );
    };

    const displayClientConfiguration = () => {
        return (
            <>
                <form>
                        <FormRow>
                            <RHFInputBox
                                labelOnLeft={true}
                                label="Attached Documents"
                                name={'attachedDocuments'}
                                style={{width: '40px'}}
                                register={registerClientInfoForm}
                                bodyStyle={{whiteSpace: 'nowrap', verticalAlign: 'middle'}}
                                readOnly={true}
                            />                        
                            {clientTypes && <RHFSelect
                                labelOnLeft={true}
                                label="Client Type:"
                                name={`clientFormatType`}
                                defaultVal={`Oil & Gas Land`}
                                options={clientTypes?.map(ct => {
                                    return { value: ct.code, label: ct.description };
                                    })}
                                register={registerClientInfoFormSection2}
                                errors={errors}
                                style={{ width: '100%' }}
                                bodyStyle={{whiteSpace: 'nowrap', width: '100%' }}
                            />}
                        </FormRow>
                        <div style={{whiteSpace: 'nowrap', display: 'flex'}}>
                            <RHFCheckbox
                                label="Master Services Agreement Required?"
                                style={{whiteSpace: 'nowrap', verticalAlign: 'middle'}}
                                labelStyle={{whiteSpace: 'nowrap', verticalAlign: 'middle'}}
                                name={'masterServicesAgreement'}
                                checked={masterServicesAgreementRequired}
                                register={registerClientInfoFormSection2}
                                bodyStyle={{whiteSpace: 'nowrap', verticalAlign: 'middle', width: '16%', marginTop: '.5rem' }}
                                errors={errors}
                                onChange={() => setMasterServicesAgreementRequired(!masterServicesAgreementRequired)}
                            />
                            <div style={{transform: 'translateY(5px)', marginLeft: '90px', display: 'flex', alignItems: 'baseline'}}>
                                <label
                                    htmlFor={'masterServicesAgreementDatePicker'}
                                    style={{marginLeft: '50px', marginRight: '5px'}}
                                >
                                    Date MSA Signed
                                </label>
                                <DatePicker
                                    className={'half-width'}
                                    name={'masterServicesAgreementDatePicker'}
                                    // selected={!!masterServicesAgreementDate ? masterServicesAgreementDate as Date : null}
                                    onChange={(date) => setMasterServicesAgreementDate(date)}
                                    placeholderText="Select a date"
                                    value={!!masterServicesAgreementDate ? (masterServicesAgreementDate as Date).toLocaleDateString() : ''}
                                />
                            </div>
                        </div>
                        <RHFCheckbox
                            label="Sub-Consultant Agreements Required?"
                            style={{whiteSpace: 'nowrap', verticalAlign: 'middle'}}
                            labelStyle={{whiteSpace: 'nowrap', verticalAlign: 'middle'}}
                            name={'subConsultantAgreement'}
                            checked={subConsultantAgreementRequired}
                            register={registerClientInfoFormSection2}
                            bodyStyle={{whiteSpace: 'nowrap', verticalAlign: 'middle', width: '16%', marginTop: '.5rem' }}
                            onChange={() => setSubConsultantAgreementRequired(!subConsultantAgreementRequired)}
                            errors={errors}
                        />
                        <RHFCheckbox
                            label="No Gift Policy?"
                            style={{whiteSpace: 'nowrap', verticalAlign: 'middle'}}
                            labelStyle={{whiteSpace: 'nowrap', verticalAlign: 'middle'}}
                            name={`noGiftPolicy`}
                            checked={noGiftPolicy}
                            onChange={() => setNoGiftPolicy(!noGiftPolicy)}
                            register={registerClientInfoFormSection2}
                            bodyStyle={{ whiteSpace: 'nowrap', verticalAlign: 'middle', width: '16%', marginTop: '.5rem' }}
                            errors={errors}
                        />
                        <RHFCheckbox
                            label="Work Order Required?"
                            style={{whiteSpace: 'nowrap', verticalAlign: 'middle'}}
                            labelStyle={{whiteSpace: 'nowrap', verticalAlign: 'middle'}}
                            name={`workOrderRequired`}
                            checked={workOrderRequired}
                            onChange={() => setWorkOrderRequired(!workOrderRequired)}
                            register={registerClientInfoFormSection2}
                            bodyStyle={{ whiteSpace: 'nowrap', verticalAlign: 'middle', width: '16%', marginTop: '.5rem' }}
                            errors={errors}
                        />
                        <RHFCheckbox
                            label="Partnership Agreements Required?"
                            style={{whiteSpace: 'nowrap', verticalAlign: 'middle'}}
                            labelStyle={{whiteSpace: 'nowrap', verticalAlign: 'middle'}}
                            name={`clientConfigPartnershipAgreementsRequired`}
                            checked={partnerAgreementRequired}
                            onChange={() => setPartnerAgreementRequired(!partnerAgreementRequired)}
                            register={registerClientInfoFormSection2}
                            bodyStyle={{ whiteSpace: 'nowrap', verticalAlign: 'middle', width: '16%', marginTop: '.5rem' }}
                            errors={errors}
                        />
                        <RHFCheckbox
                            label="Non-Disclosure Agreement Required?"
                            style={{whiteSpace: 'nowrap', verticalAlign: 'middle'}}
                            labelStyle={{whiteSpace: 'nowrap', verticalAlign: 'middle'}}
                            name={`ndaRequired`}
                            checked={ndaRequired}
                            onChange={() => setNdaRequired(!ndaRequired)}
                            register={registerClientInfoFormSection2}
                            bodyStyle={{ whiteSpace: 'nowrap', verticalAlign: 'middle', width: '16%', marginTop: '.5rem' }}
                            errors={errors}
                        />
                </form>
            </>
        );
    };

    const generateUpdatePayload = () => {
        const updatePayload = new TsdiClientInfo();
        const updatedFormData = getValuesClientInfoForm() as Partial<TsdiClientInfo>;
        const updatedSection2FormData = getValuesClientInfoFormSection2() as Partial<TsdiClientInfo>;
        updatePayload.address = (updatedFormData?.address === undefined || updatedFormData.address === '') ? null : updatedFormData.address;
        updatePayload.address2 = (updatedFormData?.address2 === undefined || updatedFormData.address2 === '') ? null : updatedFormData.address2;
        updatePayload.useBillingAddress = updatedFormData?.useBillingAddress === undefined ? null : updatedFormData.useBillingAddress;
        if (updatePayload.useBillingAddress !== null) {
            updatePayload.billingAddress = (updatedFormData?.billingAddress === undefined || updatedFormData.billingAddress === '') ? null : updatedFormData.billingAddress;
            updatePayload.billingAddress2 = (updatedFormData?.billingAddress2 === undefined || updatedFormData.billingAddress2 === '') ? null : updatedFormData.billingAddress2;
            updatePayload.billingAddress3 = (updatedFormData?.billingAddress3 === undefined || updatedFormData.billingAddress2 === '') ? null : updatedFormData.billingAddress3;
            updatePayload.billingCountry = (updatedFormData?.billingCountry === undefined || updatedFormData.billingCountry === '') ? null : updatedFormData.billingCountry;
            updatePayload.billingClientName = (updatedFormData?.billingClientName === undefined || updatedFormData.billingClientName === '') ? null : updatedFormData.billingClientName;
            updatePayload.billingCity = (updatedFormData?.billingCity === undefined || updatedFormData.billingCity === '') ? null : updatedFormData.billingCity;
            updatePayload.billingState = (updatedFormData?.billingState === undefined || updatedFormData.billingState === '') ? null : updatedFormData.billingState;
            updatePayload.billingZipCode = updatedFormData?.billingZipCode === undefined ? null : updatedFormData.billingZipCode;
        }
        updatePayload.clientName = (updatedFormData?.clientName === undefined || updatedFormData.clientName === '') ? null : updatedFormData.clientName;
        updatePayload.country = (updatedFormData?.country === undefined || updatedFormData.country === '') ? null : updatedFormData.country;
        updatePayload.city = (updatedFormData?.city === undefined || updatedFormData.city === '') ? null : updatedFormData.city;
        updatePayload.state = (updatedFormData?.state === undefined || updatedFormData.state === '') ? null : updatedFormData.state;
        updatePayload.zipCode = updatedFormData?.zipCode === undefined ? null : updatedFormData.zipCode;
        updatePayload.phone = (updatedFormData?.phone === undefined || updatedFormData.phone === '') ? null : updatedFormData.phone;
        updatePayload.fax = (updatedFormData?.fax === undefined || updatedFormData.fax === '') ? null : updatedFormData.fax;
        updatePayload.fax = (updatedFormData?.fax === undefined || updatedFormData.fax === '') ? null : updatedFormData.fax;
        updatePayload.emailAddress = (updatedFormData?.emailAddress === undefined || updatedFormData.emailAddress === '') ? null : updatedFormData.emailAddress;

        updatePayload.attachedDocuments = updatedSection2FormData?.attachedDocuments === undefined ? null : updatedSection2FormData.attachedDocuments;
        updatePayload.masterServicesAgreement = updatedSection2FormData?.masterServicesAgreement === undefined ? null : updatedSection2FormData.masterServicesAgreement;
        updatePayload.noGiftPolicy = updatedSection2FormData?.noGiftPolicy === undefined ? null : updatedSection2FormData.noGiftPolicy;
        updatePayload.workOrderRequired = updatedSection2FormData?.workOrderRequired === undefined ? null : updatedSection2FormData.workOrderRequired;
        updatePayload.partnerAgreementRequired = updatedSection2FormData?.partnerAgreementRequired === undefined ? null : updatedSection2FormData.partnerAgreementRequired;
        updatePayload.ndaRequired = updatedSection2FormData?.ndaRequired === undefined ? null : updatedSection2FormData.ndaRequired;
        // tslint:disable-next-line
        updatePayload.masterServicesAgreementDate = !!masterServicesAgreementDate ? masterServicesAgreementDate as Date : null;
        updatePayload.subConsultantAgreement = updatedSection2FormData?.subConsultantAgreement === undefined ? null : updatedSection2FormData.subConsultantAgreement;
        updatePayload.clientFormatType = (updatedSection2FormData?.clientFormatType === undefined || updatedSection2FormData.clientFormatType === '') ? null : updatedSection2FormData.clientFormatType;
        updatePayload.clientNumber = selectedClient?.clientNumber;

        return updatePayload;
    };

    const onSaveChanges = () => {
        if (isDirty || isDirtyClientInfoForm || isDirtyClientInfoFormSection2) {
            const payload = generateUpdatePayload();
            updateClientInfo(payload);
        }
    };

    return (
        <div>
            <CPNavBar/>
            <ClientProjectSearch
                setSelectedClient={setSelectedClient}
                clients={clients}
                size={6}
            />
            <div style={{display: 'flex', width: '100vw', justifyContent: 'center'}}>
                <form id="clientInfoForm" onSubmit={handleSubmit(onSubmit)}>
                    <Page className="dlc-maxer-width">
                        <Page.Section width={14}>
                            <Panel backgroundColor="#D3D3D3">
                                <Panel panelTitle={displayTitle()}>
                                    <div style={{ padding: '.5rem' }}>
                                        <div className="form-row" style={{ marginBottom: '0' }}>
                                            <div style={{display: 'flex'}}>
                                                <RHFInputBox
                                                    name={'clientNumber'}
                                                    bodyStyle={{width: '30%'}}
                                                    style={{width: '100%'}}
                                                    register={register}
                                                />
                                                <RHFInputBox
                                                    name={'clientName'}
                                                    bodyStyle={{width: '100%'}}
                                                    style={{width: '100%'}}
                                                    register={register}
                                                />
                                            </div>
                                            <Button
                                                style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                                                text={''}
                                                title="Find Client"
                                                reactIcon={BsSearch}
                                                iconHoverColor="blue"
                                                iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                                                onClick={() => findClient(false)}
                                            />
                                            <Button
                                                style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                                                text={''}
                                                title="Reports"
                                                reactIcon={VscGraph}
                                                iconHoverColor="blue"
                                                iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center', marginTop: '.4rem'}}
                                                onClick={() => reportOptions()}
                                            />
                                            <Button
                                                style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                                                text={''}
                                                title="Add New Client"
                                                reactIcon={BiAddToQueue}
                                                iconHoverColor="blue"
                                                iconStyle={{width: '2.5rem', height: '2.5rem', verticalAlign: 'center'}}
                                                onClick={() => findClient(true)}
                                            />
                                            <Button
                                                style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                                                text={''}
                                                title="Move to First Record"
                                                reactIcon={BiArrowToLeft}
                                                iconHoverColor="blue"
                                                iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                                                onClick={moveToFirstClient}
                                            />
                                            <Button
                                                style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                                                text={''}
                                                title="Move to Previous Record"
                                                reactIcon={BiLeftArrowAlt}
                                                iconHoverColor="blue"
                                                iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                                                onClick={moveToPreviousClient}
                                            />
                                            <Button
                                                style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                                                text={''}
                                                title="Save Changes"
                                                reactIcon={FaRegSave}
                                                iconHoverColor="blue"
                                                iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                                                onClick={() => onSaveChanges()}
                                            />
                                            <Button
                                                style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                                                text={''}
                                                title="Move to Next Record"
                                                reactIcon={BiRightArrowAlt}
                                                iconHoverColor="blue"
                                                iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                                                onClick={moveToNextClient}
                                            />
                                            <Button
                                                style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                                                text={''}
                                                title="Move to Last Record"
                                                reactIcon={BiArrowToRight}
                                                iconHoverColor="blue"
                                                iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                                                onClick={moveToLastClient}
                                            />
                                            <a style={{ display: 'hidden' }} id="a_voucherCheck" />
                                            <Button
                                                style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                                                text={''}
                                                title="Prospect by Manager"
                                                reactIcon={FaUserTie}
                                                iconHoverColor="blue"
                                                iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                                                onClick={() => alert('Not implemented!')}
                                            />
                                        </div>                                    
                                    </div>
                                </Panel>
                            </Panel>
                        </Page.Section>
                    </Page>
                    <Page className="dlc-maxer-width">
                        <Page.Section width={14}>
                            <Panel backgroundColor="#D3D3D3">
                                <Panel panelTitle="Client Information">
                                    <div style={{ padding: '.5rem', height: '35rem' }}>
                                        <div>
                                            {displayClientInfo()}
                                        </div>
                                    </div>
                                </Panel>
                            </Panel>
                        </Page.Section>
                        <Page.Section width={14}>
                            <Panel backgroundColor="#D3D3D3">
                                <Panel panelTitle="Client Billing Address">
                                    <div style={{ padding: '.5rem', height: '35rem' }}>
                                        <div>
                                            {displayClientBillingAddress()}
                                        </div>
                                    </div>
                                </Panel>
                            </Panel>
                        </Page.Section>
                    </Page>
                    <Page className="dlc-maxer-width">
                        <Page.Section width={14}>
                            <Panel backgroundColor="#D3D3D3">
                                <Panel>
                                    <div className="form-row" style={{ marginBottom: '0' }}>
                                        <div style={{ textAlign: 'center', overflowY: 'scroll' }}>
                                            {displayClientConfiguration()}
                                        </div>
                                    </div>
                                    <label id="BillingCodeError" style={{display: 'none', color: 'red'}}>Test</label>
                                </Panel>
                            </Panel>
                        </Page.Section>
                    </Page>
                </form>
            </div>
            <FindClientDialog 
                dialogName={DialogList.FIND_CLIENT}
                hideDialog={hideDialog}
                clients={clients}
                setClientSearchTerm={setClientSearchTerm}
                onCancel={onCancel}
                style={{maxHeight: '50vw'}}
                incrementClients={incrementClients}
                addNewClient={addingClient}
                setSelectedClient={setSelectedClient}
                mileageRate={currentMileageRate}
                onAddNewClient={addTsdiClient}
                invoiceTypes={tsdiAccounts}
                clientTypes={clientTypes}
            />
            <ReportOptionsDialog
                dialogName={DialogList.REPORT_OPTIONS}
                hideDialog={hideDialog}
                handleReport={handleReport}
                showDialog={showDialog}
            />
        </div>
    );
};

export default ClientMaintenancePage;



// WEBPACK FOOTER //
// ./src/components/client-project/pages/ClientMaintenancePage.tsx